import React from 'react';
import 'primereact/resources/themes/saga-green/theme.css';  // or any other theme
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';  // optional
import { BrowserRouter as Router, Route, Routes, BrowserRouter } from 'react-router-dom';
import { PrimeReactProvider } from 'primereact/api';
import Login from './login/Login';
import { Register } from './register/Register';
import { HospitalRegister } from './register/HospitalRegister';
import { ForgetPassword } from './forgetpassword/ForgetPassword';
import './App.css';


//admin
import AdminLayout from './layout/adminlayout/AdminLayout';
import AdminDashboard from './admin/AdminDashboard';
import { AdminHospitallist } from './admin/AdminHospitallist';
import { AdminViewhospital } from './admin/AdminViewhospital';
import { AdminDoctor } from './admin/AdminDoctor';
import { AdminViewDoctor } from './admin/AdminViewDoctor';
import { AdminPatientlist } from './admin/AdminPatientlist';
import { AdminViewPatientlist } from './admin/AdminViewPatientlist';
import { AdminCases } from './admin/AdminCases';
import { AdminViewCases } from './admin/AdminViewCases';
import { Adminsupervisorreports } from './admin/Adminsupervisorreports';
import { AdminViewSupervisorreport } from './admin/AdminViewSupervisorreport';
import { AdminDoctorreports } from './admin/AdminDoctorreports';
import { Adminviewdoctorreports } from './admin/Adminviewdoctorreports';
import { Admincasedetails } from './admin/Admincasedetails';
import { AdminPatientreports } from './admin/AdminPatientreports';
import { AdminViewPatientreport } from './admin/AdminViewPatientreport';
import { AdminCountry } from './admin/AdminCountry';
import { AdminSickness } from './admin/AdminSickness';
import { AdminSpeciality } from './admin/AdminSpeciality';
import { AdminLanguage } from './admin/AdminLanguage';
import { AdminOfficer } from './admin/AdminOfficer';
import { AdminPlan } from './admin/AdminPlan';
import { AdminActivities } from './admin/AdminActivities';
import { AdminPayments } from './admin/AdminPayments';
import { AdminDoctorNotes } from './admin/AdminDoctorNotes';
import { ViewAdminprogram } from './admin/ViewAdminprogram';
import { ViewPatientHistory } from './admin/ViewPatientHistory';
import { AdminRegions } from './admin/AdminRegions';

//doctor
import DoctorLayout from './layout/doctorlayout/DoctorLayout';
import DoctorDashboard from './doctor/DoctorDashboard';
import { DoctorCases } from './doctor/DoctorCases';
import { DoctorReports } from './doctor/DoctorReports';
import { DoctorAppointments } from './doctor/DoctorAppointments';
// import { PatientActivities } from './patient/PatientActivities';
import { DoctorProfile } from './doctor/DoctorProfile';
import { DoctorProfileUplaods } from './doctor/DoctorProfileUplaods';
import { DoctorViewOpenCase } from './doctor/DoctorViewOpenCase';
import { PatientHistory } from './doctor/PatientHistory';
import { DoctorNotes } from './doctor/DoctorNotes';
import { InvoicePrint } from './doctor/InvoicePrint';
import { Reset } from './reset/Reset';
import { DoctorActivities } from './doctor/DoctorActivities';

//consultancyofficer
import ConsultancyofficerLayout from './layout/consultancyofficerlayout/ConsultancyofficerLayout';
import { CProfile } from './consultancyofficer/CProfile';
import { ConOffActivities } from './consultancyofficer/ConOffActivities';
import { CLoginoff } from './consultancyofficer/CLoginoff';


//assistant
import AssistantLayout from './layout/assistantlayout/AssistantLayout';
import { AssistantProfile } from './assistant/AssistantProfile';
import { AssistantActivities } from './assistant/AssistantActivities';

//DoctorAppover
import DoctorApproverLayout from './layout/doctorapproverlayout/DoctorApproverLayout';
import { DoctorApproverProfile } from './doctorapprover/DoctorApproverProfile';
import { DADoctors } from './doctorapprover/DADoctors';
import { DAActivities } from './doctorapprover/DAActivities';
import { DAViewDoctor } from './doctorapprover/DAViewDoctor';

//patient
import PatientDashboard from './patient/PatientDashboard';
import PatientLayout from './layout/patientlayout/PatientLayout';
import { PatientCasesList } from './patient/PatientCasesList';
import { NewCase } from './patient/NewCase';
import { PatientFamily } from './patient/PatientFamily';
import { PatientReports } from './patient/PatientReports';
import { PatientApplications } from './patient/PatientApplications';
import { PatientNewApplications } from './patient/PatientNewApplications';
import { ViewPatientReports } from './patient/ViewPatientReports';
import { ViewPatApplication } from './patient/ViewPatApplication';
import { ViewPatientCases } from './patient/ViewPatientCases';
import { PatientActivities } from './patient/PatientActivities';
import { PatientProfile } from './patient/PatientProfile';
import { PatientUploads } from './patient/PatientUploads';
import { PatientAppointments } from './patient/PatientAppointments';
import { PatientNewCaseDetails } from './patient/PatientNewCaseDetails';
import { AddNormalCase } from './patient/AddNormalCase';
import { PayNormalCase } from './patient/PayNormalCase';
import { DoctorInfo } from './patient/DoctorInfo';
import { PatientFeedback } from './patient/PatientFeedback';

//finaceofficer
import FinaceofficerLayout from './layout/finaceofficerlayout/FinaceofficerLayout';
import { FProfile } from './financeofficer/FProfile';
import { FinanceApplication } from './financeofficer/financeApplication';
import { FinanceofficerActivities } from './financeofficer/financeofficerActivities';

//suprivisor
import SuprivisorLayout from './layout/suprivisorlayout/SuprivisorLayout';
import { SuprivisorDashboard } from './suprivisor/SuprivisorDashboard';
import { SuprivisorDoctor } from './suprivisor/SuprivisorDoctor';
import { SuprivisorAssistantlist } from './suprivisor/SuprivisorAssistantlist';
import { SuprivisorLinkAssistants } from './suprivisor/SuprivisorLinkAssistants';
import { SupDoctorDetails } from './suprivisor/SupDoctorDetails';
import { SuprivisorReports } from './suprivisor/SuprivisorReports';
import { SuprivisorActivities } from './suprivisor/SuprivisorActivities';
import { SuprivisorApplications } from './suprivisor/SuprivisorApplications';
import { SupViewDoctoeReports } from './suprivisor/SupViewDoctoeReports';
import { SupViewAssReports } from './suprivisor/SupViewAssReports';
import { SupViewApprovedApplications } from './suprivisor/SupViewApprovedApplications';
import { SuprivisorProfile } from './suprivisor/SuprivisorProfile';
import { SupViewDocuments } from './suprivisor/SupViewDocuments';
import { SupAssistantDetails } from './suprivisor/SupAssistantDetails';
import { ViewCaseDetailsSup } from './suprivisor/ViewCaseDetailsSup';
import { SupPatientHistory } from './suprivisor/SupPatientHistory';


//medicallofficeres
import MedicaOfficerLayout from './layout/medicalofficer/MedicalOfficerLayout';
import { MedicalOfficerApplications } from './medicalofficer/MedicalOfficerApplications';
import { MedicalOfficerActivities } from './medicalofficer/MedicalOfficerActivities';
import { MedicalApprovedApplication } from './medicalofficer/MedicalApprovedApplication';
import { MedicalOfficerProfile } from './medicalofficer/MedicalOfficerProfile';
import { ViewApplicationFO } from './financeofficer/ViewApplicationFO';


//mobile
import { MobCasesList } from './mobile/Mob-CasesList';
import { MobNewCase } from './mobile/MobNewCase';
import { MobNormalCase } from './mobile/MobNormalCase';
import { MobPayPal } from './mobile/MobPayPal';
import { MobUrjentCase } from './mobile/MobUrjentCase';
function App() {
  return (
    <div className="App">
      <PrimeReactProvider>
        {/* <BrowserRouter basename="/Finalprod/REACT/emedicall/medi/"> */}
        <BrowserRouter basename="/medi/">
          {/* <BrowserRouter basename={process.env.PUBLIC_URL}> */}
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Login />} />
            <Route path="/forgetpassword" element={<ForgetPassword />} />
            <Route path="/register" element={<Register />} />
            <Route path="/hospitalregister" element={<HospitalRegister />} />
            <Route path="/mobcaseslist/:uid" element={<MobCasesList />} />
            <Route path="/mobnewcase" element={<MobNewCase />} />
            <Route path="/mobnormalcase" element={<MobNormalCase />} />
            <Route path="/mobpaypal" element={<MobPayPal />} />
            <Route path="/moburgentcasecreation" element={<MobUrjentCase />} />


            {/* Admin Layout Routes */}

            <Route element={<AdminLayout />}>
              <Route path="/adashboard" element={<AdminDashboard />} />
              <Route path="/hospitallist" element={<AdminHospitallist />} />
              <Route path="/viewprogramadmin/:id" element={<ViewAdminprogram />} />
              <Route path="/viewpatienthistoryadmin/:id" element={<ViewPatientHistory />} />
              <Route path="/viewhospital/:SupervisorID" element={<AdminViewhospital />} />
              <Route path="/doctorlist" element={<AdminDoctor />} />
              <Route path="/viewdoctor/:DoctorID" element={<AdminViewDoctor />} />
              <Route path="/patientlist" element={<AdminPatientlist />} />
              <Route path="/viewpatienlist/:PatientID" element={<AdminViewPatientlist />} />
              <Route path="/caseslist" element={<AdminCases />} />
              <Route path="/viewcaseslist/:CaseID" element={<AdminViewCases />} />
              <Route path="/supervisorreport" element={<Adminsupervisorreports />} />
              <Route path="/viewsupervisorreport/:SupervisorID" element={<AdminViewSupervisorreport />} />
              <Route path="/doctorreport" element={<AdminDoctorreports />} />
              <Route path="/viewdoctorreport/:DoctorID" element={<Adminviewdoctorreports />} />
              <Route path="/admincasedetails/:CaseID" element={<Admincasedetails />} />
              <Route path="/patientreports" element={<AdminPatientreports />} />
              <Route path="/viewpatientreports/:PatientID" element={<AdminViewPatientreport />} />
              <Route path="/admincountry" element={<AdminCountry />} />
              <Route path="/sicknesslist" element={<AdminSickness />} />

              <Route path="/speciality" element={<AdminSpeciality />} />
              <Route path="/language" element={<AdminLanguage />} />
              <Route path="/officers" element={<AdminOfficer />} />
              <Route path="/plans" element={<AdminPlan />} />
              <Route path="/adminactivities" element={<AdminActivities />} />
              <Route path="/regions" element={<AdminRegions />} />
              <Route path="/adminpayments" element={<AdminPayments />} />
              <Route path="/adoctornotes/:id" element={<AdminDoctorNotes />} />



            </Route>

            {/* Doctor */}


            <Route element={<DoctorLayout />}>
              <Route path="/doctordashboard" element={<DoctorDashboard />} />
              <Route path="/doctorcaseslists" element={<DoctorCases />} />
              <Route path="/doctorreports" element={<DoctorReports />} />
              <Route path="/doctorappointments" element={<DoctorAppointments />} />
              <Route path="/doctoractivities" element={<DoctorActivities />} />
              <Route path="/doctorprofile" element={<DoctorProfile />} />
              <Route path="/doctoruploads" element={<DoctorProfileUplaods />} />
              <Route path="/casedetails/:id" element={<DoctorViewOpenCase />} />
              <Route path="/viewpatienthistory/:id" element={<PatientHistory />} />
              <Route path="/doctornotes/:id" element={<DoctorNotes />} />
              <Route path="/invoice/:id" element={<InvoicePrint />} />
              <Route path="/doctorresetpassword" element={<Reset />} />

            </Route>

            {/* consultancyofficer */}
            <Route element={<ConsultancyofficerLayout />}>
              <Route path="/cprofile" element={<CProfile />} />
              <Route path="/coactivities" element={<ConOffActivities />} />
              <Route path="/cologin" element={<CLoginoff />} />
              <Route path="/cprofile" element={<CProfile />} />

            </Route>

            <Route element={<AssistantLayout />}>
              <Route path="/assistantprofile" element={<AssistantProfile />} />
              <Route path="/assistantactivities" element={<AssistantActivities />} />

            </Route>
            {/* medicalofficer */}

            {/* DoctorApprover */}
            <Route element={<DoctorApproverLayout />}>
              <Route path="/daprofile" element={<DoctorApproverProfile />} />
              <Route path="/dadoctors" element={<DADoctors />} />
              <Route path="/daactivity" element={<DAActivities />} />
              <Route path="/viewdadoctorslists/:id" element={<DAViewDoctor />} />

            </Route>
            {/*patient */}
            <Route element={<PatientLayout />}>
              <Route path="/patientdashboard" element={<PatientDashboard />} />
              <Route path="/patientcases" element={<PatientCasesList />} />
              <Route path="/createnewcase" element={<NewCase />} />
              <Route path="/patientfamily" element={<PatientFamily />} />
              <Route path="/patientappointments" element={<PatientAppointments />} />
              <Route path="/patreports" element={<PatientReports />} />
              <Route path="/patientapplications" element={<PatientApplications />} />
              <Route path="/newapplicationpatient" element={<PatientNewApplications />} />
              <Route path="/viewpatreports/:id" element={<ViewPatientReports />} />
              <Route path="/viewpatapplications/:id" element={<ViewPatApplication />} />
              <Route path="/viewpatientcases/:id" element={<ViewPatientCases />} />
              <Route path="/patientactivities" element={<PatientActivities />} />
              <Route path="/patientprofile" element={<PatientProfile />} />
              <Route path="/patientuploads" element={<PatientUploads />} />
              <Route path="/urgentcasecreation" element={<PatientNewCaseDetails />} />
              <Route path="/addnormalcase" element={<AddNormalCase />} />
              <Route path="/paypal" element={<PayNormalCase />} />
              <Route path="/doctorsinformation/:id" element={<DoctorInfo />} />
              <Route path="/patientfeedback/:id" element={<PatientFeedback />} />
              <Route path="/patientresetpassword" element={<Reset />} />
              <Route path="/patientinvoice/:id" element={<InvoicePrint />} />


            </Route>
            {/* finaceofficer */}
            <Route element={<FinaceofficerLayout />}>
              <Route path="/fprofile" element={<FProfile />} />
              <Route path="/fpapplications" element={<FinanceApplication />} />
              <Route path="/fiofnactivities" element={<FinanceofficerActivities />} />
              <Route path="/fviewapprove/:id" element={<ViewApplicationFO />} />
              <Route path="/fviewapplied/:id" element={<ViewApplicationFO />} />
              <Route path="/fviewall/:id" element={<ViewApplicationFO />} />
            </Route>

            {/* medicalofficer */}
            <Route element={<MedicaOfficerLayout />}>
              <Route path="/medicalofficerapplications" element={<MedicalOfficerApplications />} />
              <Route path="/mactivity" element={<MedicalOfficerActivities />} />
              <Route path="/mviewapproved/:id" element={<MedicalApprovedApplication />} />
              <Route path="/mviewapplied/:id" element={<MedicalApprovedApplication />} />
              <Route path="/mviewall/:id" element={<MedicalApprovedApplication />} />
              <Route path="/mprofile" element={<MedicalOfficerProfile />} />

            </Route>

            <Route element={<SuprivisorLayout />}>
              <Route path="/sdashboard" element={<SuprivisorDashboard />} />
              <Route path="/sdoctors" element={<SuprivisorDoctor />} />
              <Route path="/sassistantlist" element={<SuprivisorAssistantlist />} />
              <Route path="/slinkassistants" element={<SuprivisorLinkAssistants />} />
              <Route path="/viewdoctors/:id" element={<SupDoctorDetails />} />
              <Route path="/sreports" element={<SuprivisorReports />} />
              <Route path="/sactivity" element={<SuprivisorActivities />} />
              <Route path="/sapplications" element={<SuprivisorApplications />} />
              <Route path="/viewdoctorreports/:id" element={<SupViewDoctoeReports />} />
              <Route path="/viewassitantreports/:id" element={<SupViewAssReports />} />
              <Route path="/viewapprovedapplications/:id" element={<SupViewApprovedApplications />} />
              <Route path="/supprofile" element={<SuprivisorProfile />} />
              <Route path="/viewdocuments" element={<SupViewDocuments />} />
              <Route path="/viewassistantdetails/:id" element={<SupAssistantDetails />} />
              <Route path="/supresetpassword" element={<Reset />} />
              <Route path="/viewdoctorcases/:id" element={<ViewCaseDetailsSup />} />
              <Route path="/patienthistory" element={<SupPatientHistory />} />

            </Route>

          </Routes>
        </BrowserRouter>
      </PrimeReactProvider>
    </div>
  );
}

export default App;
